import { render, staticRenderFns } from "./assineiCPR-marca-by-aliare.svg?vue&type=template&id=338e8fe6"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports